import * as types from '../constants/ActionTypes';
import api from '../../config/api.js';

export function setPractice(practice){
	return (dispatch) => {
			dispatch({
				type: types.SET_APP_PRACTICE,
				payload: practice
			})
	}
}

export function fetchSessions(patientRecordId, from = '') {
	return async (dispatch) => {
		console.log('Fetch Sessions');
		try {
			const sessions = await api.get(`/patients/sessions/${patientRecordId}/${from}`);
			if (sessions.data) {
				dispatch({
					type: types.SET_SESSIONS,
					payload: sessions.data
				})
				return Promise.resolve(sessions.data)
			}
			console.log('No Session Data');
			return Promise.resolve([]);
		} catch (error) {
			console.log('Error getting patient sessions from server', error)
			dispatch({
				type: types.SET_SESSIONS,
			 	payload: {}
		 	})
			return Promise.reject()
		}
	}
}

export function fetchTherapistPatients(therapistId) {
	return (dispatch) => {
		return api.get(`/therapists/${therapistId}/patients`)
		.then(d => {
				 dispatch({
					type: types.SET_PATIENTS,
					payload: d.data
				})
				return d.data
			})
			.catch(e => {
				console.log('Error getting therapist patients from server')
				return Promise.reject()
			})
	}
}

export function fetchTherapistPatient(therapistId, patientId) {
	return (dispatch) => {
		api.get(`/therapists/${therapistId}/patients/${patientId}`)
			.then(d => {
				dispatch({
					type: types.SET_PATIENTS,
					payload: [d.data]
				})
			})
			.catch(e => {
				console.log('Error getting therapist patient from server')
			})
	}
}

export function deleteTherapistPatient(therapistId, patientId) {
	return (dispatch) => {
		api.delete(`/therapists/${therapistId}/patients/${patientId}`)
			.then(d => {

			})
			.catch(e => {
				console.log('Error delete therapist patient from server')
			})
	}
}

export function archiveTherapistPatient(therapistId, patientId) {
	return (dispatch) => {
		return api.get(`/therapists/${therapistId}/patients/${patientId}/archive`)
			.then(d => {
				dispatch({
					type: types.SET_PATIENTS,
					payload: [d.data]
				})
			})
			.catch(e => {
				console.log('Error archiving therapist patient from server')
			});
	}
}

export function unarchiveTherapistPatient(therapistId, patientId) {
	return (dispatch) => {
		return api.get(`/therapists/${therapistId}/patients/${patientId}/unarchive`)
			.then(d => {
				dispatch({
					type: types.SET_PATIENTS,
					payload: [d.data]
				})
			})
			.catch(e => {
				console.log('Error archiving therapist patient from server')
			});
	}
}

export function fetchTherapistPatientsForPractice(therapistId, practiceId) {
	return (dispatch) => {
		return api.get(`/therapists/${therapistId}/practice/${practiceId}/patients`)
			.then(d => {
				return dispatch({
					type: types.SET_PATIENTS,
					payload: d.data
				})
			})
			.catch(e => {
				console.log('Error getting therapist patients for practice from server', e)
				return Promise.reject({msg: 'Error getting therapist patients for practice from server', error: e})
			})
	}
}

export function fetchTherapistPatientRecord(therapistId, practiceId, patientId){
	return (dispatch) => {
		return api.get(`/therapists/${therapistId}/practice/${practiceId}/patient/${patientId}/record`)
			.then(d => {
				let patientRecord = {
					'patient': patientId,
					'therapist': therapistId,
					'practice': practiceId
				}

				if(d.data && d.data.length){
					patientRecord = d.data[0]
					dispatch({
						type: types.SET_PATIENT_RECORD,
						payload: patientRecord
					})
				}
				return Promise.resolve(patientRecord)
			})
			.catch(e => {
				console.log('Error getting therapist patient record from server', e)
				return Promise.reject(e)
			})
	}
}

export function fetchAllTherapistPatientRecord(therapistId, practiceId, patientId){
	return (dispatch) => {
		return api.get(`/therapists/${therapistId}/practice/${practiceId}/patient/${patientId}/fullrecord`)
			.then(d => {
				let patientRecord = {
					'patient': patientId,
					'therapist': therapistId,
					'practice': practiceId
				}

				if(d.data.length){
					patientRecord = d.data[0]
					dispatch({
						type: types.SET_PATIENT_RECORD,
						payload: patientRecord
					})
				}
				return Promise.resolve(patientRecord)
			})
			.catch(e => {
				console.log('Error getting therapist patient record from server', e)
				return Promise.reject(e)
			})
	}
}

export function fetchPatientAssessments(therapistId,recordId){
	return async (dispatch) => {
		console.log('Fetch Assessments');
		return await api.get(`/therapists/${therapistId}/assessments/record/${recordId}`)
			.then(d => {
				if(d.data.length){
					dispatch({
						type: types.SET_ASSESSMENTS,
						payload: d.data
					})
				}
				return Promise.resolve(d.data)
			})
			.catch(e => {
				console.log('Error getting patient assessments from server', e)
				return Promise.reject(e)
			})
	}
}

export function savePatientRecord(patientRecord){
	return (dispatch) => {
		api.post(`/therapists/${patientRecord.therapist}/records`, patientRecord)
		.then( d => {
			dispatch({
				type: types.SET_PATIENT_RECORD,
				payload: d.data
			})
		})
		.catch(e => {
			console.log('Error saving therapist patient record from server', e)
		})
	}
}

export function saveSession(session){
	return async (dispatch) => {
		let isNew = !session._id;
		return await api.post(`/therapists/${session.therapist}/sessions`, session)
		.then( d => {
			return dispatch({
				type: isNew ? types.INSERT_SESSION : types.SET_SESSION,
				payload: d.data
			})
		})
		.catch(e => {
			console.log('Error saving therapist session from server', e)
			return false;
		})
	}
}

export function deleteSession(therapistId,sessionId ){
	return async (dispatch) => {
		return await api.delete(`/therapists/${therapistId}/sessions/${sessionId}`)
		.then( d => {
			return dispatch({
				type: types.REMOVE_SESSION,
				payload: d.data
			})
		})
		.catch(e => {
			console.log('Error deleting therapist session from server', e)
			return false;
		})
	}
}

export function createAssessment(therapistId, assessment) {
	return (dispatch) => {
		return api.post(`/therapists/${therapistId}/assessments`, assessment)
			.then(d => {
				// if(d.data){
				// 	dispatch({
				// 		type: types.SET_ASSESSMENT,
				// 		payload: d.data
				// 	})
				// }
				return d.data;
			})
			.catch(e => {
				console.log('Error adding assessment at server', e)
				return e;
			})
	}
}

export function saveAssessment(therapistId, assessment) {
	return (dispatch) => {
		api.post(`/therapists/${therapistId}/assessments`)
			.then(d => {
				dispatch({
					type: types.SET_ASSESSMENT,
					payload: [d.data]
				})
			})
			.catch(e => {
				console.log('Error adding assessment at server', e)
			})
	}
}


export function savePatient(therapistId,practiceId, patient){
	return (dispatch) => {
		return api.post(`/therapists/${therapistId}/practice/${practiceId}/patients`, patient)
		.then( d => {
			dispatch({
				type: types.SET_PATIENT,
				payload: d.data
			})
		})
		.catch(e => {
			console.log('Error saving therapist patient from server', e)
		})
	}
}



// WEBPACK FOOTER //
// ./src/actions/therapist.js